export default __webpack_public_path__ + "media/images/images_v2/zoom-51579bcd35b1d6694e5e0925ddc98485.png";